import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { CommonModule, DatePipe } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, NgModule, OnChanges, OnInit, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NotificationService } from '@services/notification.service';
import { TestService } from '@services/test.service';
import { WebErrorService } from '@services/webError.service';
import { MatSelectFilterModule } from 'mat-select-filter';
import { Editor, NgxEditorModule, Toolbar } from 'ngx-editor';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { customValidationService } from 'src/app/shared/custom.validator';


export interface Examinee {
  fullName: string;
}

@Component({
  selector: 'app-create-public-schedule',
  templateUrl: './create-public-schedule.component.html',
  styleUrls: ['./create-public-schedule.component.scss']
})
export class CreatePublicScheduleComponent implements OnInit, AfterViewInit, OnChanges {


  // public schedule form
  publicScheduleForm: FormGroup;

  // date initialization
  minDate: Date;
  minDate1: Date;
  d = new Date();
  timeZoneArr = [];
  zone: any;
  convertStartTime: any;
  minutesToAdd: any;
  setDefaultStartTime: any;
  setDefaultEndTime: any;
  convertEndTime: any;

  // editor initialization
  editor: Editor;
  editor1: Editor;
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  // mat chip and autocomplete
  public allExaminees: Examinee[] = [];

  public chipSelectedExaminee: Examinee[] = [];

  public filteredExaminee: Observable<String[]>;

  private allowFreeTextAddExaminee = false;

  public examineeControl = new FormControl();
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  @ViewChild('examineeInput') examineeInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  setPenaltymsg: boolean;
  setTestScoremsg: boolean;
  isExamineeExist = false;
  getMarksDetails: any;
  isStartTimeValid: boolean;
  isEndTimeValid: boolean;

  // search dropdown
  searchOptions = [];
  selected: any;
  filteredList: any[] = [];

  isWrongExamineeValue: boolean = false;
  isMultipleSameExamineeValue: boolean = false;
  readonly allowedExaminees: Array<string> = ['uuid', 'fname', 'lname', 'email', 'userid', 'classid', 'assessmentid', 'enrollmentid', 'assignmentid', 'phone'];

  isAllowAttempts: boolean = false;
  maxAttempts: number = 0;
  weeks: number = 0;
  days: number = 0;
  hours: number = 0;
  validateParam: boolean = false;
  thirdpartyname: any;
  isParameterVisible: boolean = true;

  createParamList = [{key: 'uuid', value: this.translate.instant('examineeLogin.demoGraphic.parameterPublic.uuid'), checked: false},
    {key: 'email', value: this.translate.instant('examineeLogin.demoGraphic.parameterPublic.email'), checked: false},
    {key: 'fname', value: this.translate.instant('examineeLogin.demoGraphic.parameterPublic.fname'), checked: false},
    {key: 'lname', value: this.translate.instant('examineeLogin.demoGraphic.parameterPublic.lname'), checked: false},
    {key: 'phone', value: this.translate.instant('examineeLogin.demoGraphic.parameterPublic.phone'), checked: false},
    {key: 'enrollmentid', value: this.translate.instant('examineeLogin.demoGraphic.parameterPublic.enrollmentid'), checked: false},
    {key: 'assessmentid', value: this.translate.instant('examineeLogin.demoGraphic.parameterPublic.assessmentid'), checked: false},
    {key: 'classid', value: this.translate.instant('examineeLogin.demoGraphic.parameterPublic.classid'), checked: false},
    {key: 'userid', value: this.translate.instant('examineeLogin.demoGraphic.parameterPublic.userid'), checked: false},
    {key: 'assignmentid', value: this.translate.instant('examineeLogin.demoGraphic.parameterPublic.assignmentid'), checked: false}
  ]

  constructor(private fb: FormBuilder, private testService: TestService, private notificationService: NotificationService, private datePipe: DatePipe, private cd: ChangeDetectorRef, private webErrorService: WebErrorService, private translate : TranslateService
  ,private renderer: Renderer2) {
    this.renderer.listen('window', 'click',(e:Event)=>{
      if (this.examineeInput != undefined) {
        if(e.target !== this.examineeInput.nativeElement) {
          this.isMultipleSameExamineeValue = false;
          this.isWrongExamineeValue = false;
          this.cd.detectChanges();
        }
      }
    })

    // /////////////////////////////////////// date logic ////////////////////////////////////////
    // this.minDate = new Date(Date.now() - (3600 * 1000 * 24));
    // this.minDate1 = new Date(Date.now() - (3600 * 1000 * 24));
    // //  convert time to current time to plus 30 minute
    // this.convertStartTime = new Date();
    // this.minutesToAdd = new Date(
    //   this.convertStartTime.setMinutes(this.convertStartTime.getMinutes() + 30)
    // );

    // this.setDefaultStartTime =
    //   this.minutesToAdd.getHours() + ':' + this.minutesToAdd.getMinutes();

    // this.convertEndTime = this.convertStartTime.setMinutes(
    //   this.convertStartTime.getMinutes() + 60
    // );
    // this.setDefaultEndTime =
    //   this.convertStartTime.getHours() +
    //   ':' +
    //   this.convertStartTime.getMinutes();
    // ////////////////////////////////////////////////////////////////////////////////////////////

    // editor logic
    this.editor = new Editor();
    this.editor1 = new Editor();
  }

  counter(i: number) {
    return new Array(i);
  }

  ngOnInit(): void {
    /////////////////////////////////////// date logic ////////////////////////////////////////
    this.minDate = new Date(Date.now() - (3600 * 1000 * 24));
    this.minDate1 = new Date(Date.now() - (3600 * 1000 * 24));
    //  convert time to current time to plus 30 minute
    this.convertStartTime = new Date();
    this.minutesToAdd = new Date(
      this.convertStartTime.setMinutes(this.convertStartTime.getMinutes() + 30)
    );

    this.setDefaultStartTime =
      this.minutesToAdd.getHours() + ':' + this.minutesToAdd.getMinutes();

    this.convertEndTime = this.convertStartTime.setMinutes(
      this.convertStartTime.getMinutes() + 60
    );
    this.setDefaultEndTime =
      this.convertStartTime.getHours() +
      ':' +
      this.convertStartTime.getMinutes();
    ////////////////////////////////////////////////////////////////////////////////////////////
    this.getTimeZone();
    // this.getPublicExaminees();
    this.buildPublicScheduleForm();
    this.getMarks();
    this.filteredExaminee = this.examineeControl.valueChanges.pipe(
      map(examineeName => this.filterOnValueChange(examineeName))
    );
  }

  ngAfterViewInit(): void {
    /////////////////////////////////////// date logic ////////////////////////////////////////
    this.minDate = new Date(Date.now() - (3600 * 1000 * 24));
    this.minDate1 = new Date(Date.now() - (3600 * 1000 * 24));
    //  convert time to current time to plus 30 minute
    this.convertStartTime = new Date();
    this.minutesToAdd = new Date(
      this.convertStartTime.setMinutes(this.convertStartTime.getMinutes() + 30)
    );

    this.setDefaultStartTime =
      this.minutesToAdd.getHours() + ':' + this.minutesToAdd.getMinutes();

    this.convertEndTime = this.convertStartTime.setMinutes(
      this.convertStartTime.getMinutes() + 60
    );
    // this.setDefaultEndTime =
    //   this.convertStartTime.getHours() +
    //   ':' +
    //   this.convertStartTime.getMinutes();
    ////////////////////////////////////////////////////////////////////////////////////////////
    this.cd.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    /////////////////////////////////////// date logic ////////////////////////////////////////
    this.minDate = new Date(Date.now() - (3600 * 1000 * 24));
    this.minDate1 = new Date(Date.now() - (3600 * 1000 * 24));
    //  convert time to current time to plus 30 minute
    this.convertStartTime = new Date();
    this.minutesToAdd = new Date(
      this.convertStartTime.setMinutes(this.convertStartTime.getMinutes() + 30)
    );

    this.setDefaultStartTime =
      this.minutesToAdd.getHours() + ':' + this.minutesToAdd.getMinutes();

    this.convertEndTime = this.convertStartTime.setMinutes(
      this.convertStartTime.getMinutes() + 60
    );
    // this.setDefaultEndTime =
    //   this.convertStartTime.getHours() +
    //   ':' +
    //   this.convertStartTime.getMinutes();
    ////////////////////////////////////////////////////////////////////////////////////////////
    this.cd.detectChanges();
  }

  // form validation
  get f() {
    this.publicScheduleForm.valueChanges.subscribe(valueChange => {
      this.compareDateAndTime(valueChange);
    });
    return this.publicScheduleForm.controls;
  }


  compareDateAndTime(valueChange): any {
    if (valueChange.startTime == '' || valueChange.startTime == '00:00') {
      this.isStartTimeValid = true;
    } else {
      this.isStartTimeValid = false;
    }
    if (valueChange.endTime == '' || valueChange.endTime == '00:00') {
      this.isEndTimeValid = true;
    } else {
      this.isEndTimeValid = false;
    }
  }

  // create public schedule form
  buildPublicScheduleForm() {

    this.publicScheduleForm = this.fb.group({
      schName: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(120),Validators.pattern(/^[ a-zA-Z.-]+([ ]?[a-z0-9 !#|^*()-_@$!%*?&]){0,}$/),customValidationService.cannotContainSpace]),
      schDescription: new FormControl({ value: null, disabled: false },
        [
          Validators.maxLength(480),
        ]),
      startDate: new FormControl({ value: new Date(), disabled: false }, Validators.required),
      startTime: new FormControl({ value: this.setDefaultStartTime, disabled: false }, Validators.required),
      endDate: new FormControl({ value: new Date(), disabled: false }, Validators.required),
      endTime: new FormControl({ value: this.setDefaultEndTime, disabled: false }, Validators.required),
      timeZone: new FormControl({ disabled: false }, Validators.required),
      testDuration: new FormControl({ value: '10', disabled: false }, [Validators.required, Validators.pattern(/^(?=.*[0-9])(?:[0-9]\d*\.?|0?\.)\d*$/)]),
      testTotalScore: new FormControl({ disabled: false }, Validators.required),
      testPassingScore: new FormControl({ value: '1', disabled: false }, [Validators.required]),
      penaltyPoints: new FormControl({ value: '0', disabled: false }, [Validators.required]),
      preMessageText: new FormControl({ value: 'Welcome to assessment test', disabled: false }, [Validators.required, Validators.minLength(8), Validators.maxLength(25000)]),
      postMessageText: new FormControl({ value: 'Test submitted successfully', disabled: false }, [Validators.required, Validators.minLength(8), Validators.maxLength(25000)]),
      ExamineeRejoinTest: new FormControl({ value: '', disabled: true }, Validators.required),
      showResultAfterTest: new FormControl({ value: '', disabled: true }, Validators.required),
      shuffleItems: new FormControl({ value: '', disabled: true }, Validators.required),
      shuffleQuestions: new FormControl({ value: '', disabled: true }, Validators.required),
      shuffleOptions: new FormControl({ value: '', disabled: true }, Validators.required),
      iallquestionsmandatory: new FormControl({ value: false, disabled: false }),
      MaxAttempts: new FormControl({ value: 0}),
      Weeks: new FormControl({ value: 0}),
      days: new FormControl({ value: 0}),
      hours: new FormControl({ value: 0}),
      showTools: new FormControl({ value: true, disabled: false }),
      showItemList: new FormControl({ value: true, disabled: false }),
      AutoUniqueId: new FormControl({ value: true, disabled: false })
    });
  }

  // merge fname and emailid
  getFnameNemailId(firstName, emailId) {
    return `${firstName} (${emailId})`;
  }


  /////////////////////////////////////// start add and remove recipient logic //////////////////////////////////////////////
  // add new chip
  public addExaminee(event: MatChipInputEvent): void {
    // if (!this.allowFreeTextAddExaminee) {
    //   // only allowed to select from the filtered autocomplete list
    //   return;
    // }

    // //
    // // Only add when MatAutocomplete is not open
    // // To make sure this does not conflict with OptionSelected Event
    // //
    // if (this.matAutocomplete.isOpen) {
    //   return;
    // }

    // // Add our examinee
    // const value = event.value;
    // if ((value || '').trim()) {
    //   this.selectExamineeByName(value.trim());
    // }

    // this.resetInputs();
    const value = event.value ? event.value.trim() : null;

    if (!value) {
      event.chipInput!.clear();
      return;
    }

    // Add our fruit
    this.isWrongExamineeValue = false;
    this.isMultipleSameExamineeValue = false;

    const isValueAlreadySelected = this.chipSelectedExaminee.some(item => item.fullName === value);

    if (value && this.allowedExaminees.includes(value) && !isValueAlreadySelected) {
      this.chipSelectedExaminee.push({ fullName: value });
      this.isExamineeExist = false;
    } else if (isValueAlreadySelected) {
      this.isMultipleSameExamineeValue = true;
    } else {
      this.isWrongExamineeValue = true;
    }
    // Clear the input value
    event.chipInput!.clear();
  }

  // remove chip
  public removeExaminee(examinee: Examinee): void {
    const index = this.chipSelectedExaminee.indexOf(examinee);
    if (index >= 0) {
      this.chipSelectedExaminee.splice(index, 1);
      if (this.chipSelectedExaminee.length === 0) {
        this.isExamineeExist = true;
        return;
      }
      this.resetInputs();
    }
  }

  // selected examinee
  public selectedExaminee(event: MatAutocompleteSelectedEvent): void {
    this.selectExamineeByName(event.option.value);
    this.resetInputs();
  }

  // reset add recipient input box
  private resetInputs() {
    // clear input element
    this.examineeInput.nativeElement.value = '';
    // clear control value and trigger examineeControl.valueChanges event
    this.examineeControl.setValue(null);
  }

  // filter add recipient input box on change value
  private filterOnValueChange(examineeName: string | null): String[] {
    let result: String[] = [];
    //
    // Remove the examinees we have already selected from all examinees to
    // get a starting point for the autocomplete list.
    //
    let allExamineesLessSelected = this.allExaminees.filter(examinee => this.chipSelectedExaminee.indexOf(examinee) < 0);
    if (examineeName) {
      result = this.filterExaminee(allExamineesLessSelected, examineeName);
    } else {
      result = allExamineesLessSelected.map(examinee => examinee.fullName);
    }
    return result;
  }

  // filter examinee after detect any change
  private filterExaminee(examineeList: Examinee[], examineeName: String): String[] {
    let filteredExamineeList: Examinee[] = [];
    const filterValue = examineeName.toLowerCase();
    let examineesMatchingEngineerName = examineeList.filter(examinee => examinee.fullName.toLowerCase().indexOf(filterValue) === 0);
    if (examineesMatchingEngineerName.length || this.allowFreeTextAddExaminee) {
      //
      // either the examinee name matched some autocomplete options
      // or the name didn't match but we're allowing
      // non-autocomplete examinee names to be entered
      //
      filteredExamineeList = examineesMatchingEngineerName;
    } else {
      //
      // the examinee name didn't match the autocomplete list
      // and we're only allowing examinees to be selected from the list
      // so we show the whjole list
      //
      filteredExamineeList = examineeList;
    }
    //
    // Convert filtered list of examinee objects to list of examinee
    // name strings and return it
    //
    return filteredExamineeList.map(examinee => examinee.fullName);
  }


  private selectExamineeByName(examineeName) {
    let foundExaminee = this.allExaminees.filter(examinee => examinee.fullName == examineeName);
    if (foundExaminee.length) {
      //
      // We found the examinee name in the allExaminees list
      //
      this.chipSelectedExaminee.push(foundExaminee[0]);
      if (this.chipSelectedExaminee.length > 0) {
        this.isExamineeExist = false;
        return;
      }
    }
  }

  /////////////////////////////////////// end add and remove recipient logic //////////////////////////////////////////////

  ////////////////////////////////////// not used anywhere in html /////////////////////////////////////////////////////////
  testScoreChange() {
    if (
      this.publicScheduleForm?.value?.testPassingScore + 1 >
      // this.scheduleForm.controls['testPassingScore'].value || this.scheduleForm.controls['penaltyPoint'].value >
      this.publicScheduleForm?.value?.testTotalScore
    ) {

      this.setTestScoremsg = true;
      setTimeout(() => {
        this.setTestScoremsg = false;
      }, 1000);
      // this.publicScheduleForm.value.testPassingScore.patchValue({ testPassingScore: '0' });
    } else {
      this.setTestScoremsg = false;
    }

  }


  checkTestValue() {
    if (
      this.publicScheduleForm.value.penaltyPoints + 1 >
      this.publicScheduleForm?.value?.testTotalScore
    ) {
      this.setPenaltymsg = true;
      // this.publicScheduleForm.patchValue({ penaltyPoints: '0' });
    } else {
      this.setPenaltymsg = false;
    }

  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////


  // get all time zones
  getTimeZone(): void {
    this.testService.getTimeZone().subscribe((timezonedata) => {
      this.timeZoneArr = timezonedata?.data;
      // Dropdown Search filter
      this.searchOptions = this.timeZoneArr;
      this.selected = this.searchOptions[0]?.name;
      this.filteredList = this.searchOptions.slice();
      this.cd.detectChanges();
    },
    (error: any) => {
      this.webErrorService.handleAPIErrors(error);
    });
  }

  // get all existing public examinees
  getPublicExaminees(): void {
    this.testService.getExamineetoSchedule().subscribe((resData) => {

      const fullInfo = resData.items.map((value) => (
        { fullName: this.getFnameNemailId(value['firstName'], value['emailId']), examineeuuid: value['examineeuuid'], examineeId: value['examineeId'] }
      ));
      this.allExaminees = fullInfo;
    },
    (error: any) => {
      this.webErrorService.handleAPIErrors(error);
    });
  }

  // get marks
  getMarks(): void {
    const testuuid = sessionStorage.getItem('testuuid');
    const marks = this.testService.getTestToltalScore(testuuid).subscribe((resData) => {
      this.publicScheduleForm.patchValue({
        testTotalScore: resData?.data?.totalMarks, testPassingScore: resData?.data?.passingCriteria, testDuration: resData?.data?.duration, timeZone: resData?.data?.collectionTimeZone
      });
    },
    (error: any) => {
      this.webErrorService.handleAPIErrors(error);
    });
  }

  // navigate to back
  back() {
    this.testService.scheduleBackBtnobs.next(false);
  }

  // submit public schedule form
  onSubmit(form) {
    if (this.chipSelectedExaminee.length <= 0 && !this.isParameterVisible) {
      this.isExamineeExist = true;
      return;
    }
    // this.thirdpartyname = JSON.parse(sessionStorage.getItem('currentUser'))
    // const examinneNames = this.chipSelectedExaminee.map((value) => value.fullName);
    // if (!examinneNames.includes('uuid') && !examinneNames.includes('email') && this.thirdpartyname.thirdpartyname == 'lms' && !this.isParameterVisible) {
    //   this.validateParam = true;
    //   return;
    // } else {
    //   this.validateParam = false;

    // }

    // if (form.value.testPassingScore > form.value.testTotalScore) {
    //   this.webErrorService.customErrors('Passing Score can not be greater than test score', true, 'warn')
    //   return;
    // }

    // if (form.value.penaltyPoints > form.value.testTotalScore) {
    //   this.webErrorService.customErrors('Penalty points can not be greater than test score', true, 'warn')
    //   return;
    // }
    let newDate: Date = new Date();
    let schEndDate = this.publicScheduleForm.value.startDate;

    if (parseInt(form.value?.Weeks) > 0) newDate.setDate(schEndDate.getDate() + parseInt(form.value?.Weeks) * 7);
    if (parseInt(form.value?.days) > 0) newDate.setDate(newDate.getDate() + parseInt(form.value?.days))
    if (parseInt(form.value?.hours) > 0) {
      // let startTime = this.publicScheduleForm.value.startTime;
      // newDate.setHours(startTime + parseInt(form.value?.hours))
    }

    if (parseInt(form.value?.Weeks) > 0 || parseInt(form.value?.days) > 0 || parseInt(form.value?.hours) > 0) {
      if (((this.datePipe.transform(this.publicScheduleForm.value.endDate, 'yyyy-MM-dd')) < this.datePipe.transform(newDate, 'yyyy-MM-dd'))
         ) {
        this.webErrorService.customErrors(this.translate.instant('test.createSchedule.public.AttemptError'), true, 'warn');
        return;
      }
      // console.log(this.publicScheduleForm.value.endTime)
      // console.log(newDate.getHours() + ':'+ newDate.getMinutes())
      // if (((this.datePipe.transform(this.publicScheduleForm.value.endDate, 'yyyy-MM-dd')) <= this.datePipe.transform(newDate, 'yyyy-MM-dd') &&
      // this.publicScheduleForm.value.endTime < (newDate.getHours() + ':'+ newDate.getMinutes()))) {
      //   alert('Please select schedule time');
      // }
    }

    const finalPayload = this.getFinalPayload(form);
    this.testService.addTestSchedule(finalPayload).subscribe((resData) => {
      if (resData.success) {
        this.notificationService.success(resData?.message);
        this.back();
      }
    },
    (error: any) => {
      this.webErrorService.handleAPIErrors(error, null, true, 'warn');
    });
  }

  // construct api payload
  getFinalPayload(payload): any {
    const examinneNames = this.chipSelectedExaminee.map((value) => value.fullName);
    return payload = {
      examinees: [],
      publicScheduleParameters: {
        parameters: examinneNames
      },
      clientuuId: JSON.parse(sessionStorage?.getItem('currentUser'))?.clientuuId,
      collectionId: sessionStorage.getItem('defaultcollectionid'),
      description: payload?.value?.schDescription?.trim() || null,
      endDate: this.datePipe.transform(payload.value.endDate, 'yyyy-MM-dd'),
      endDateHours: payload.value.endTime.split(':')[0],
      endDateMinutes: payload.value.endTime.split(':')[1],
      postTestMessage: {
        description: payload?.value?.postMessageText?.trim(),
        mediaURL: [
          "String"
        ]
      },
      preTestMessage: {
        description: payload?.value?.preMessageText?.trim(),
        mediaURL: [
          "String"
        ]
      },
      scheduleType: true,
      iallquestionsmandatory: payload?.value?.iallquestionsmandatory,
      startDate: this.datePipe.transform(payload.value.startDate, 'yyyy-MM-dd'),
      startDateHours: payload.value.startTime.split(':')[0],
      startDateMinutes: payload.value.startTime.split(':')[1],
      testBankId: sessionStorage.getItem('testBankId'),
      testDuration: payload?.value?.testDuration,
      testPassingScore: JSON.parse(payload?.value?.testPassingScore),
      testScore: JSON.parse(payload?.value?.testTotalScore),
      penaltyPoint: payload?.value?.penaltyPoints,
      timeZoneName: payload?.value?.timeZone,
      title: payload.value.schName.trim(),
      maxnumberofattempts: payload?.value?.MaxAttempts,
      allowreattemptafterweeks: payload?.value?.MaxAttempts == 0 ? payload?.value?.Weeks.value : payload?.value?.Weeks,
      allowreattemptafterdays: payload?.value?.MaxAttempts == 0 ? payload?.value?.days.value : payload?.value?.days,
      allowreattemptafterhours: payload?.value?.MaxAttempts == 0 ? payload?.value?.hours.value : payload?.value?.hours,
      showtools: payload?.value?.showTools,
      showitemlist: payload?.value?.showItemList,
      Isautogenerateuniqueid: payload?.value?.AutoUniqueId
    }
  }

  onSelectMaxAttempts(event) {
    console.log(event.target.value);
    if (event.target.value != 0) {
      this.isAllowAttempts = true;
    } else {
      this.publicScheduleForm.value.Weeks = 0;
      this.publicScheduleForm.value.days = 0;
      this.publicScheduleForm.value.hours = 0;
      this.weeks = 0;
      this.days = 0;
      this.hours = 0;
      this.isAllowAttempts = false;
    }
  }

  onSelectAutoGenerateUniqueID(event) {
    this.isParameterVisible = true;
    this.chipSelectedExaminee = [];
    if (event.checked == false) {
      this.isParameterVisible = false;
    }
  }

  onSelectParam(param, event) {
    const value = param ? param.trim() : null;

    this.isWrongExamineeValue = false;
    this.isMultipleSameExamineeValue = false;

    if (event.checked == false) {
      this.removeSelectedParam(value);
    } else {
      const isValueAlreadySelected = this.chipSelectedExaminee.some(item => item.fullName === value);

      if (value && this.allowedExaminees.includes(value) && !isValueAlreadySelected) {
        this.chipSelectedExaminee.push({ fullName: value });
        this.isExamineeExist = false;
      } else if (isValueAlreadySelected) {
        this.isMultipleSameExamineeValue = true;
      } else {
        this.isWrongExamineeValue = true;
      }
    }
  }

  removeSelectedParam(value) {
    var index = this.chipSelectedExaminee.findIndex(item => item.fullName === value);
    if (index >= 0) {
      this.chipSelectedExaminee.splice(index, 1);
      if (this.chipSelectedExaminee.length === 0) {
        this.isExamineeExist = true;
        return;
      }
      this.resetInputs();
    }
  }
}
@NgModule({
  declarations: [
    CreatePublicScheduleComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatChipsModule,
    MatIconModule,
    MatInputModule,
    MatCheckboxModule,
    MatDatepickerModule,
    NgxMaterialTimepickerModule,
    MatSlideToggleModule,
    NgxEditorModule,
    MatButtonModule,
    MatSelectModule,
    MatSelectFilterModule,
    FormsModule,
    TranslateModule
  ]
})
class CreatePublicScheduleComponentModule {

}
